import {
  SHOP_LIST_SEARCH, SHOP_LIST_SEARCH_FAILURE, SHOP_LIST_SEARCH_SUCCESS, SHOP_DELETE, SHOP_DELETE_FAILURE, SHOP_DELETE_SUCCESS
} from './mutation-types'

export default {
  state: {
    shops: [],
    shopListNextPage: null,
    shopListCurrentPage: null
  },
  getters: {
    shopList: state => {
      return state.shops
    },
    shopListNextPage: state => {
      return state.shopListNextPage
    },
    shopListCurrentPage: state => {
      return state.shopListCurrentPage
    }
  },
  actions: {
    [SHOP_LIST_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/master/shops'
      var callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        data = params.data
      }
      if ('callback' in params) {
        callback = params.callback
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHOP_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(SHOP_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [SHOP_DELETE] ({dispatch, state, commit}, params) {
      var data = params.data
      dispatch('apiDelete', {url: '/master/shops/' + params.id, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHOP_DELETE_FAILURE, res.data)
          } else {
            commit(SHOP_DELETE_SUCCESS, { data: res.data, callback: params.callback })
            window.location.reload(false)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [SHOP_LIST_SEARCH_FAILURE] (state, params) {
      console.log('SHOP_LIST_SEARCH_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [SHOP_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('SHOP_LIST_SEARCH_SUCCESS')
      var data = params.data
      var reSearch = false
      if (data.meta && data.meta['re-search']) {
        reSearch = data.meta['re-search']
      }
      if (reSearch) {
        // 再検索
        state.shops = data.data
        if (data.meta['next-page'] === null) {
          state.shopListNextPage = null
        }
      } else {
        if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
          state.shops = state.shops.concat(data.data)
          state.shopListCurrentPage = data.meta['current-page']
        } else {
          state.shops = data.data
          state.shopListCurrentPage = 1
        }
        if (data.links && data.links['next']) {
          state.shopListNextPage = data.links['next']
        } else {
          state.shopListNextPage = null
        }
      }
      if (params.callback) {
        params.callback()
      }
    },
    [SHOP_DELETE_FAILURE] (state, data) {
      console.log('SHOP_DELETE_FAILURE')
    },
    [SHOP_DELETE_SUCCESS] (state, data) {
      console.log('SHOP_DELETE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shop-list.js